import React from "react";

export const PlaylistNotFound = () => {
    return (
        <div className='nothingFound'>
            <h2>Can’t find that playlist...</h2>
            <p className='grayColor'>Please try again or clear the search field.</p>
        </div>
    )
}